import api from '@/api'

const { $pricing, $academic} = api;

export const { $prepaids, $types, $zones, $installments } = $pricing;
export const { $terms, $careers } = $academic;